export default __webpack_public_path__ + "static/media/coresanscr65it-webfont.402200b3.woff";